/* eslint-disable react/no-direct-mutation-state */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import _isEmpty from 'lodash/isEmpty';
import { formMessageConstants } from '../../utils/constants/form-message-constants';
import { formFieldConstants } from '../../utils/constants/form-field-constants';
import { formConstants } from '../../utils/constants/form-constants';
import initialState from '../helpers/form-helpers/initial-state';
import { isEmpty, deepCopyObject } from '../../utils/obj-utils';
import FormSpinner from '../../common/utility/FormSpinner';
import FormMessage from '../../common/utility/FormMessage';
import FormBuilder from '../helpers/form-builder';
import * as registerFormActions from '../../../store/actions/register-form-actions';
import * as userAddressActions from '../../../store/actions/user-address-actions';
import * as formScrollHelpers from '../helpers/form-scroll-helper';
import * as formStateHelpers from '../helpers/form-helpers/form-state-helper';
import * as formFieldDisplayHelpers from '../helpers/form-helpers/form-field-display-helpers';
import { findOptionInSelectField } from '../helpers/form-helpers/form-field-helpers';
import SSOFormHeader from '../../common/utility/SSOFormHeader';
import SSOFormFooter from '../../common/utility/SSOFormFooter';
import RegisterFormBanner from '../one-club-register/RegisterFormBanner';
import GTMUserActions from '../../common/utility/GTMUserActions';
import { hasValue } from '../../../../../general/js/general-helpers';
import { getFormContainerWideLeftClassList, getModalContentClassListForSSOForm, toggleBemClassesForSSOFormModal } from '../helpers/form-helpers/form-modal-helpers';
import { ssoFormTypes } from '../../utils/form-types';

class TicketingRegisterForm extends Component {
    constructor(props) {
        super(props);

        const { registerFormData, ssoDomain } = this.props;

        this.state = {
            ...initialState.ticketingRegisterFormState,
            ssoDomain,
            isModalStylingUpdated: false
        };

        this.formMessageRef = React.createRef();
        this.formReference = React.createRef();
        this.formReferences = formScrollHelpers.getFormReferences(registerFormData);

        this.loadRegisterFormData = this.loadRegisterFormData.bind(this);
        this.displayTicketingRegisterForm = this.displayTicketingRegisterForm.bind(this);
        this.displayForm = this.displayForm.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleValidationResult = this.handleValidationResult.bind(this);
        this.handleUserRegisterSuccess = this.handleUserRegisterSuccess.bind(this);
        this.submitRegisterData = this.submitRegisterData.bind(this);
        this.finishFormSubmit = this.finishFormSubmit.bind(this);

        this.loadRegisterFormData();
    }

    loadRegisterFormData() {
        const { actions, registerFormData } = this.props;

        if (isEmpty(registerFormData)) {
            actions.loadSSORegisterFormData();
        }
    }

    componentDidMount() {
        this.state.isModalStylingUpdated = toggleBemClassesForSSOFormModal(this.formReference, this.props, ssoFormTypes.TicketingRegister);
    }

    componentWillReceiveProps(nextProps) {
        const {
            isRegisterSuccessful,
            registerFormData,
            loading,
            isUserAddressRetrieveSuccessful,
            retrievedUserAddress
        } = nextProps;

        if (hasValue(registerFormData) && !this.state.isModalStylingUpdated) {
            this.state.isModalStylingUpdated = toggleBemClassesForSSOFormModal(this.formReference, nextProps, ssoFormTypes.TicketingRegister);
        }

        if (!loading && isUserAddressRetrieveSuccessful) {
            const { county, state } = registerFormData;
            this.setState(formStateHelpers.handleAddressDataChange(retrievedUserAddress, county, state));
        }

        if (!isEmpty(registerFormData) && isEmpty(this.formReferences)) {
            this.formReferences = formScrollHelpers.getFormReferences(registerFormData);
        }

        if (!loading &&
            isRegisterSuccessful) {
            this.setState(formStateHelpers.updateSavingState(false), this.handleUserRegisterSuccess);
            return;
        }

        if (!loading &&
            !isRegisterSuccessful) {
            this.setState(formStateHelpers.updateSavingState(false),
                () => {
                    formScrollHelpers.scrollToField(this.formMessageRef);
                });
        }
    }

    componentWillUnmount() {
        const { actions } = this.props;
        this.setState(initialState.ticketingRegisterFormState);
        actions.resetRegisterFormState();
    }

    handleUserRegisterSuccess() {
        const { onUserRegisterSuccess } = this.props;
        const {
            formType,
            actionSuccessText,
            requestEmailVerificationCallbackUrl,
            requestEmailVerificationActionSuccessText
        } = this.props.registerFormData;

        GTMUserActions.trackTicketingAccountAction();

        onUserRegisterSuccess(this.state[formConstants.emailAddress],
            {
                registerFormType: formType,
                successText: actionSuccessText,
                emailVerificationCallbackUrl: requestEmailVerificationCallbackUrl,
                emailVerificationActionSuccessText: requestEmailVerificationActionSuccessText
            });
    }

    async handleSubmit(event) {
        event.preventDefault();
        const { registerFormData } = this.props;
        const { reCaptcha } = this.state;

        if (reCaptcha) {
            registerFormData.reCaptchaToken = reCaptcha;
        }

        this.setState(formStateHelpers.handleFormValidation(registerFormData), this.handleValidationResult);
    }

    handleValidationResult() {
        if (this.state.formHasErrors) {
            const { errors } = this.state;
            formScrollHelpers.scrollToInvalidField(errors, this.formReferences);
            return;
        }
        const captchaRef = this.formReferences[formConstants.reCaptcha];

        if (captchaRef) {
            captchaRef.current.props.grecaptcha.reset();
        }

        this.setState(formStateHelpers.updateSavingState(true), this.submitRegisterData);
    }

    submitRegisterData() {
        const { registerFormData } = this.props;

        GTMUserActions.trackTicketingAccountActionClick();

        if (registerFormData.membership) {
            this.setState({ membership: registerFormData.membership, ssoEmailNotificationSettingsFields: registerFormData.ssoEmailNotificationSettingsFields }, () => {
                this.finishFormSubmit();
            });
            return;
        }

        this.finishFormSubmit();
    }

    finishFormSubmit() {
        const { actions, registerFormData } = this.props;
        const { callBackUrlPost } = registerFormData;
        const actionSuccessText = registerFormData.actionSuccessText || formMessageConstants.registrationSuccessText;

        formScrollHelpers.scrollToField(this.formReferences[formConstants.dateOfBirth]);
        actions.registerNewUser(this.state, actionSuccessText, callBackUrlPost);
        this.setState({ reCaptcha: '' });
    }

    displayForm() {
        const {
            onSignIn,
            onForgotPassword,
            isRegisterSuccessful,
            userRegistrationMessages,
            registerFormData
        } = this.props;

        if (isEmpty(registerFormData)) {
            return null;
        }

        const { formHeader } = registerFormData;

        return (<Fragment>
            <SSOFormHeader
                headerTitle={formHeader.headerTitle}
                headerMessage={formHeader.headerMessage}
                headerLinkText={formHeader.headerLinkText}
                headerSecondMessage={formHeader.headerSecondMessage}
                headerSecondLinkText={formHeader.headerSecondLinkText}
                secondLinkCallBackUrl={onForgotPassword}
                linkCallBackUrl={onSignIn}
                displaySecondMessageAndLink={true}></SSOFormHeader>
            <form onSubmit={this.handleSubmit}>
                <FormMessage
                    formRef={this.formMessageRef}
                    isSuccessMessage={isRegisterSuccessful}
                    messages={userRegistrationMessages}></FormMessage>
                {this.displayTicketingRegisterForm()}
                <SSOFormFooter
                    onSubmit={this.handleSubmit}
                    footerButtonText={formMessageConstants.submitTicketingFormButtonText}
                    footerLinkText={`${formMessageConstants.alreadyAMember} ${formMessageConstants.signInHere}`}
                    linkCallBackUrl={onSignIn}></SSOFormFooter>
            </form>
        </Fragment>);
    }

    displayTicketingRegisterForm() {
        const { actions, registerFormData } = this.props;
        const { availableCounties, country, availableStates } = this.state;
        const { county, mobilePhone, state } = registerFormData;
        const copyOfRegisterFormData = deepCopyObject(registerFormData);
        const stateFieldDefaultValue = findOptionInSelectField(copyOfRegisterFormData[formConstants.state], this.state[formConstants.state], formFieldConstants.selectFieldOptionsCode);

        copyOfRegisterFormData[formConstants.country].defaultValue = this.state[formConstants.country];
        copyOfRegisterFormData[formConstants.county].defaultValue = this.state[formConstants.county];
        copyOfRegisterFormData[formConstants.state].defaultValue = stateFieldDefaultValue;
        copyOfRegisterFormData[formConstants.city].defaultValue = this.state[formConstants.city];
        copyOfRegisterFormData[formConstants.addressLine1].defaultValue = this.state[formConstants.addressLine1];
        copyOfRegisterFormData[formConstants.addressLine2].defaultValue = this.state[formConstants.addressLine2];
        copyOfRegisterFormData[formConstants.addressLine3].defaultValue = this.state[formConstants.addressLine3];
        copyOfRegisterFormData[formConstants.postcode].defaultValue = this.state[formConstants.postcode];

        return FormBuilder({
            formData: copyOfRegisterFormData,
            formReferences: this.formReferences,
            countryData: { selectedCountry: country },
            countyData: { availableCounties, label: county ? county.label : formMessageConstants.emptyString },
            stateData: { availableStates, label: state ? state.label : formMessageConstants.emptyString },
            handleChange: (event) => { this.setState(formStateHelpers.handleFieldChange(event.target)); },
            handleFieldChange: (event) => { this.setState(formStateHelpers.handleFieldChangeWithValidation(event.target)); },
            handleConfirmPasswordChange: (event) => { this.setState(formStateHelpers.handleConfirmPasswordFieldChange(event.target)); },
            handleDateChange: (event) => { this.setState(formStateHelpers.handleDateChange(event)); },
            handleMobilePhoneChange: (event) => { this.setState(formStateHelpers.handleMobilePhoneChange(event, mobilePhone.isOptional)); },
            handleCaptchaChange: (token) => { this.setState(formStateHelpers.handleCaptchaChange(token)); },
            handleMastercardNumberChange: (event) => {
                this.setState(formStateHelpers.handleMastercardNumberChange(event.target,
                    registerFormData.mastercardRegex, registerFormData.mastercardValidationError));
            },
            handleCountryChange: (event) => {
                this.setState(formStateHelpers.handleCountryChange(event.target, county, state),
                    () => {
                        actions.resetRetrievedUserAddress();
                    });
            },
            handleFieldValidState: (fieldName) => {
                const { errors } = this.state;
                return formFieldDisplayHelpers.handleFieldValidState(fieldName, errors);
            },
        });
    }

    render() {
        const { isSaving } = this.state;
        const { loading, registerFormData } = this.props;
        const { formBanner, desktopImageSrc, mobileImageSrc } = registerFormData;

        return (
            <div ref={this.formReference} className={getModalContentClassListForSSOForm(this.props)}>
                <div className={getFormContainerWideLeftClassList(this.props)}>
                    {
                        hasValue(mobileImageSrc) &&
                        <div>
                            <img src={mobileImageSrc} className='form-container__banner--mobile' data-sizes="auto" />
                        </div>
                    }
                    <RegisterFormBanner
                        formBanner={formBanner}
                    ></RegisterFormBanner>
                    <div className='form-container__form'>
                        {(isSaving || loading) ? <FormSpinner>/</FormSpinner> : null}
                        {this.displayForm()}
                    </div>
                </div>
                {
                    hasValue(desktopImageSrc) &&
                    <div className='form-container__wide--right'>
                        <img src={desktopImageSrc} className='form-container__banner--desktop' data-sizes="auto" />
                    </div>
                }
            </div>
        );
    }
}

TicketingRegisterForm.propTypes = {
    loading: PropTypes.bool.isRequired,
    onSignIn: PropTypes.func.isRequired,
    onUserRegisterSuccess: PropTypes.func.isRequired,
    ssoDomain: PropTypes.string,
    registerFormData: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {
        loading: state.apiStatus.apiCallsInProgress > 0,
        registerFormData: _isEmpty(ownProps.registerFormData) ? state.registerForm.registerFormData : ownProps.registerFormData,
        isRegisterSuccessful: state.registerForm.isRegisterSuccessful,
        userRegistrationMessages: state.registerForm.userRegistrationMessages,
        isUserAddressRetrieveSuccessful: state.userAddressSearchData.isUserAddressRetrieveSuccessful,
        retrieveAddressMessages: state.userAddressSearchData.retrieveAddressMessages,
        retrievedUserAddress: state.userAddressSearchData.retrievedUserAddress
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            loadSSORegisterFormData: bindActionCreators(registerFormActions.loadSSOTicketingRegisterFormData, dispatch),
            registerNewUser: bindActionCreators(registerFormActions.registerNewUser, dispatch),
            resetRegisterFormState: bindActionCreators(registerFormActions.resetRegisterFormState, dispatch),
            resetRetrievedUserAddress: bindActionCreators(userAddressActions.resetRetrievedUserAddress, dispatch)
        }
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TicketingRegisterForm);
